import { InventoryBundleFragment } from '@control-tower/platform-wms';
import { asArraySafe } from '@pf/shared-utility';

export function containerHasAssignedBundles(container: {
    inventoryBundles?: Array<InventoryBundleFragment> | null;
}): boolean {
    return asArraySafe(container.inventoryBundles).length > 0;
}
